<template>
  <v-card>
    <v-data-table
      id="report_list"
      :headers="headers"
      :items="items"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <tr class="cursor-pointer" 
        >
        <!-- :class="getRowColor(props.item.preparation_time, differenceInMs[props.index])" -->
          <td
            v-for="header in headers"
            :key="header.value"
            :class="`text-xs-${header.align}`"
            class="py-2"
          >
            <span v-if="header.value === 'store_name'" class="text-xs-left">
              {{ props.item.store_name }}
            </span>
            <span
              v-if="header.value === 'index'"
              class="text-xs-center"
              style="display: flex; align-items: center; width: 200px"
            >
              <v-icon
                class="font-weight-light pr-2"
                :color="getServiceTypeColor(props.item.service_type)"
                >{{ props.item.icon }}
              </v-icon>
              <!-- <br /> -->
              <span>
                {{ `#${props.item.check_number}` }}
                <span v-if="props.item.service_type === 3">
                  /{{ props.item.table_name }}
                </span>
              </span>
            </span>

            <span v-else-if="header.value === 'kot_number'">
              {{ props.item.kot_number }}
            </span>

            <!-- Adding ICON timer and KOT notes || 26-03-2026 -->
            <span v-else-if="header.value === 'menu_name'">
              <span>
                <div>
                  {{ props.item.menu_name }}
                   <v-icon class="py-n2 font-weight-bolder" v-if="isPrepTimeOver(props.item.preparation_time, differenceInMs[props.index])" :class="GetPrepTimerColor(props.item.preparation_time, differenceInMs[props.index])"
                   >flaticon-auto-hold</v-icon>
                </div>
                <v-icon v-if="props.item.call_back_item_action" class="green--text ml-1" title="Item Restored" small>undo</v-icon>
              </span>
              <span v-if="props.item.kot_instruction"  class="brown--text">
                {{ props.item.kot_instruction }}
                <v-icon v-if="props.item.kot_instruction"  small color="brown">flaticon-notes</v-icon>
              </span>
              <!-- Modifiers -->
              <div class="pink--text" v-if="props.item.modifier_receipe">
                <div
                  v-for="modifier in deletedIncludedModifiers(
                    props.item.modifier_receipe
                  )"
                  :key="modifier.id"
                  class="strike--text error--text"
                >
                  <span>{{ modifier.name }}</span>
                </div>
                <div
                  v-for="modifier in selectedModifiers(
                    props.item.modifier_receipe
                  )"
                  :key="modifier.id"
                >
                  {{ modifier.name }}
                </div>
              </div>
              <!-- Instructions -->
              <div
                class="orange--text"
                v-for="(instruction, idx) in props.item.instructions"
                :key="`instruction-${idx}`"
              >
                -> {{ instruction }}
              </div>
            </span>

            <span v-else-if="header.value === 'quantity'">
              <!-- Additive: on a multi-portion line the quantity opens the
                   partial dialog. Every existing row action is untouched. -->
              <div
                class="item-qty"
                :class="{ 'item-qty--tappable': canPickQuantity(props.item) }"
                :title="canPickQuantity(props.item) ? 'Tap to select quantity for Food Ready' : ''"
                @click="onQtyClick($event, props.item)"
              >
                {{ props.item.quantity }}
              </div>
              <!-- Ready/total for the original line, next to the quantity. -->
              <span
                v-if="readyProgress(props.item, items)"
                class="caption green--text font-weight-bold"
              >
                {{ readyProgress(props.item, items) }}
              </span>
            </span>

            <span v-else-if="header.value === 'kot_user_name'">
              {{ props.item.kot_user_name }}
            </span>

            <span :class="GetPrepTimerColor(props.item.preparation_time, differenceInMs[props.index])" v-else-if="header.value === 'kot_sent_time'">
              {{ props.item.kot_sent_time }}
            </span>

            <span :class="GetPrepTimerColor(props.item.preparation_time, differenceInMs[props.index])" v-else-if="header.value === 'time'">
              <div v-if="props.item.status >= 4">
                {{ props.item.prepared_at }}
              </div>
              <timer
                v-else
                :class="GetPrepTimerColor(props.item.preparation_time, differenceInMs[props.index])"
                :date="`${props.item.sale_open_date}`"
                :time="`${props.item.kot_sent_time}`"
                @milli-seconds="updateTimeInMs($event, props.index)"
              ></timer>
            </span>

            <span
              class="text-xs-right sticky elm"
              v-else-if="header.value === 'status'"
            >
              <!-- <v-chip outline label small :color="props.item.color" v-if="props.item.statusInfo">
            {{ props.item.statusInfo.name }}
          </v-chip> -->
          
              <action-btn
                :showServed="showServed"
                :item.sync="props.item"
                :act="act"
                :serve="true"
              ></action-btn>
            </span>
          </td>
        </tr>
      </template>
    </v-data-table>
    <qty-picker
      :show.sync="showQtyPicker"
      :item="qtyPickerItem"
      :status="qtyPickerStatus"
      @select="onQtySelect"
    ></qty-picker>
  </v-card>
</template>
<script>
// let getHeaders = (showStoreName, viewType) => {
//   let headers = [
//     { text: "##", align: "center", sortable: false, class: "clm1" },
//     { text: "Kot #", align: "center", sortable: false },
//     { text: "Item", align: "left", sortable: false, class: "item-name-clm" },
//     { text: "Qty", align: "center", sortable: false },
//     { text: "Kot By", align: "center", sortable: false },
//     { text: "Kot Time", align: "center", sortable: false },
//     {
//       text: viewType === "bump-out" ? "Prepared Time" : "Time",
//       align: "center",
//       sortable: false,
//     },
//     {
//       text: "Status",
//       align: "right",
//       sortable: false,
//       class: "status-clm sticky-elm header",
//     },
//   ];

//   if (showStoreName) {
//     headers.unshift({
//       text: "Store Name",
//       align: "left",
//       value: "store_name",
//       sortable: false,
//     });
//   }
//   return headers;
// };

import timer from "@/components/utils/timer";
import ActionBtn from "@/components/action";
import Mixin from "@/components/utils/mixin";
import qtyPicker from "@/components/qtyPicker";
import { getRowColor,isPrepTimeOver,GetPrepTimerColor } from "@/helper/helper.js";

export default {
  components: { timer, ActionBtn, "qty-picker": qtyPicker },
  props: {
    items: Array,
    viewType: { type: String, default: "list" },
  },
  mixins: [Mixin],
  data() {
    return {
      pagination: {
        rowsPerPage: 10,
        page: 1,
        sortBy: "",
        descending: false,
      },
      differenceInMs: new Array(this.items.length),
      showQtyPicker: false,
      qtyPickerItem: null,
      qtyPickerStatus: 4,
      getRowColor,
      isPrepTimeOver,
      GetPrepTimerColor
    };
  },
  methods: {
    updateTimeInMs(v, index) {
      this.differenceInMs.splice(index, 1, v);
    },
    act(item, status, call_back_item, serve_item = false, quantity) {
      // Same interception as the grid view: Food Ready on a multi-portion line
      // asks how many first.
      let kitchenLine = JSON.parse(localStorage.getItem("kitchenLine"));

      this.setItemStatus(
        item.ticket_name,
        kitchenLine.id,
        item,
        status,
        call_back_item,
        serve_item,
        quantity
      );
    },
    onQtySelect({ item, quantity }) {
      this.act(item, this.qtyPickerStatus, false, false, quantity);
    },
    getColor(item) {
      let now = new Date();
      let sent_time = new Date(
        `${now.getFullYear()}-${now.getMonth()}-${now.getDate()} ${
          item.kot_sent_time
        }`
      );
      var diff = now - sent_time;
      var min = Math.round(((diff % 86400000) % 3600000) / 60000);

      // console.log(min)
      if (min >= 15) return "red lighten-4";
      if (min >= 10) return "yellow lighten-4";
      return "";
    },
    getServiceTypeColor(type) {
      if (type == 1) return "success";
      if (type == 2) return "pink";
      if (type == 3) return "indigo";
      if (type == 4) return "error";
      return "brown";
    },
  },
  computed: {
    showServed() {
      return this.$store.getters.showServed;
    },
    showStoreName() {
      return this.$store.getters.showStoreName;
    },
    headers() {
      return this.$store.getters.getCheckViewColumns.filter((c) => c.enabled);
    },
  },
};
</script>
<style>
.clm1 {
  width: 60px !important;
}
.item-name-clm {
  min-width: 300px !important;
}
.status-clm {
  width: 60px !important;
}
table.v-table thead {
  /* height: 50px !important; */
  background: #ff5a10;
}
table.v-table thead tr {
  height: 40px !important;
}
table.v-table thead th {
  font-weight: 600 !important;
  font-size: 14px !important;
  opacity: 1;
  color: aliceblue !important;
}
.v-datatable__progress {
  display: none;
}
#report_list td,
#report_list th {
  font-size: 16px !important;
  font-weight: 700;
  height: unset !important;
  min-height: 40px !important;
}

.sticky-elm {
  background-color: #fff;
  position: sticky;
  right: 0;
  border-collapse: separate;
}
.sticky-elm.header {
  background-color: #ff5a10;
}

.item-percent-eighty {
  color: #000000 !important;
}

.item-percent-hundred {
  color: #000000 !important;
}

.item-percent-eighty2 {
  color: #000000 !important;
  background: #ff5a10;
}

.item-percent-hundred2 {
  background: #f7020a !important;
  color: #000000 !important;
}
</style>
